
import { callExternalApi } from "./external-api.service";
import { UploadType } from "../common/enums";

const apiServerUrl = process.env.REACT_APP_API_SERVER;

export const getEvents = async (accessToken) => {
    const config = {
        url: `${apiServerUrl}/events`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const getEventWithContent = async (event_id, accessToken) => {
    const config = {
        url: `${apiServerUrl}/event/${event_id}`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const getUserContent = async (accessToken) => {
    const config = {
        url: `${apiServerUrl}/usercontent`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const getPublishedEvents = async () => {
    const config = {
        url: `${apiServerUrl}/get-published-events`,
        method: "GET",
        headers: {
            "content-type": "application/json"
        },
    };
    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const getPublishedEvent = async (event_id) => {
    const config = {
        url: `${apiServerUrl}/published-event/${event_id}`,
        method: "GET",
        headers: {
            "content-type": "application/json"
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const getEventAnalytics = async (event_id, accessToken) => {
    const config = {
        url: `${apiServerUrl}/analytics/event/${event_id}`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const getCreatorAnalytics = async (timeRange, accessToken) => {
    const config = {
        url: `${apiServerUrl}/analytics/creator/summary`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        params: {
            time_range: timeRange // '7d', '30d', '90d'
        }
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const getAudienceAnalytics = async (accessToken) => {
    const config = {
        url: `${apiServerUrl}/analytics/audience`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const getMyTickets = async (accessToken) => {
    const config = {
        url: `${apiServerUrl}/my-tickets`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const purchaseTicketsV2 = async (ticketInfoId, accessToken, donationAmount = null) => {
    const payload = {
        ticket: {
            ticketinfo_id: ticketInfoId
        }
    };

    // Add donation amount if provided and greater than 0
    if (donationAmount && parseFloat(donationAmount) > 0) {
        payload.donation_amount = parseFloat(donationAmount);
    }

    const config = {
        url: `${apiServerUrl}/create-checkout-session`,
        method: "POST",
        data: payload,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const getSessionStatus = async (sessionId, accessToken) => {
    const config = {
        url: `${apiServerUrl}/session-status`,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
        params: {
            session_id: sessionId
        }
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const CheckUserPaid = async (eventId, accessToken) => {
    const config = {
        url: `${apiServerUrl}/has-user-paid`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
        params: {
            event_id: eventId
        }
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
}

export const getPaidContent = async (contentId, accessToken) => {
    const payload = {
        content_id: contentId
    }

    const config = {
        url: `${apiServerUrl}/get-paid-content`,
        withCredentials: true,
        method: "POST",
        data: payload,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });
    console.log("Data:", data)
    console.log("Error:", error)

    return {
        data: data,
        error: error,
    };
};

export const getPreviewContent = async (contentId, accessToken) => {
    const payload = {
        content_id: contentId
    }

    const config = {
        url: `${apiServerUrl}/get-preview-content`,
        withCredentials: true,
        method: "POST",
        data: payload,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });
    console.log("Data:", data)
    console.log("Error:", error)

    return {
        data: data,
        error: error,
    };
}

export const getUploadUrls = async (event_id, content_id, filename, upload_type, num_parts, accessToken) => {
    console.log("num_parts: " + num_parts);
    console.log("Upload Type:", upload_type)
    const payload = {
        contentId: content_id,
        eventId: event_id,
        filename: filename,
        num_parts: num_parts,
    }

    let url_suffix;
    switch (upload_type) {
        case UploadType.content:
            url_suffix = 'getContentPreSignedUrlsV2';
            break;
        case UploadType.contentAsset:
            url_suffix = 'getContentAssetPreSignedUrlsV2';
            break;
        case UploadType.eventAsset:
            url_suffix = 'getEventAssetPresignedUrls';
            break;
        default:
            throw new Error('Invalid upload type');
    }

    const config = {
        url: `${apiServerUrl}/${url_suffix}`,
        method: "POST",
        data: payload,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const completeUpload = async (event_id, content_id, asset_id, parts, upload_id, upload_type, accessToken) => {
    const payload = {
        contentId: content_id,
        eventId: event_id,
        assetId: asset_id,
        upload_id: upload_id,
        parts: parts,
    }

    let url_suffix;
    switch (upload_type) {
        case UploadType.content:
            url_suffix = 'completeContentUploadV2';
            break;
        case UploadType.contentAsset:
            url_suffix = 'completeContentAssetUploadV2';
            break;
        case UploadType.eventAsset:
            url_suffix = 'completeEventAssetUpload';
            break;
        default:
            throw new Error('Invalid upload type');
    }

    const config = {
        url: `${apiServerUrl}/${url_suffix}`,
        method: "POST",
        data: payload,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });
    console.log("Data:", data)
    console.log("Error: ", error)

    return {
        data: data || null,
        error,
    };
};

export const createEvent = async (eventName, eventDetails, fromDate, toDate, accessToken) => {
    const payload = {
        name: eventName,
        details: eventDetails,
        from_date: fromDate,
        to_date: toDate
    }
    const config = {
        url: `${apiServerUrl}/event`,
        method: "POST",
        data: payload,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const saveEvent = async (eventId, eventName, eventDetails, fromDate, toDate, accessToken) => {
    const payload = {
        id: eventId,
        name: eventName,
        details: eventDetails,
        from_date: fromDate,
        to_date: toDate
    }
    const config = {
        url: `${apiServerUrl}/save-event`,
        method: "POST",
        data: payload,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const saveContent = async (contentId, contentInfo, accessToken) => {
    const payload = {
        id: contentId,
        info: contentInfo
    }
    const config = {
        url: `${apiServerUrl}/save-content`,
        method: "POST",
        data: payload,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const deleteContent = async (contentId, accessToken) => {
    const payload = {
        id: contentId
    }
    const config = {
        url: `${apiServerUrl}/delete-content`,
        method: "POST",
        data: payload,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const deleteDraft = async (event_id, accessToken) => {
    const payload = {
        eventId: event_id
    }
    const config = {
        url: `${apiServerUrl}/delete-draft-event`,
        method: "POST",
        data: payload,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const publishEvent = async (event_id, accessToken) => {
    const payload = {
        eventId: event_id
    }
    const config = {
        url: `${apiServerUrl}/publish-event`,
        method: "POST",
        data: payload,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const cancelEvent = async (event_id, accessToken) => {
    const payload = {
        eventId: event_id
    }
    const config = {
        url: `${apiServerUrl}/cancel-event`,
        method: "POST",
        data: payload,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const createEventTickets = async (eventId, tickets, accessToken) => {
    const payload = {
        tickets: tickets.map(ticket => ({
            event_id: eventId,
            name: ticket.name,
            details: ticket.details || {},
            price: parseFloat(ticket.price),
            quantity: parseInt(ticket.quantity, 10)
        }))
    };

    const config = {
        url: `${apiServerUrl}/ticketinfo/`,
        method: "POST",
        data: payload,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        },
    };

    const { data, error } = await callExternalApi({ config });
    return {
        data: data || null,
        error,
    };
};

export const updateEventTickets = async (eventId, tickets, accessToken, donationSettings = null) => {
    const payload = {
        event_id: eventId,
        tickets: Array.isArray(tickets) ? tickets.map(ticket => ({
            id: ticket.id, // Include ID if it exists (for existing tickets)
            name: ticket.name,
            details: { description: ticket.details?.description || ticket.description || '' },
            price: parseFloat(ticket.price),
            quantity: parseInt(ticket.quantity, 10)
        })) : []
    };

    // Add donation settings to the payload if provided
    if (donationSettings) {
        payload.donationSettings = donationSettings;
    }

    const config = {
        url: `${apiServerUrl}/ticketinfo`,
        method: "PUT",
        data: payload,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        },
    };

    const { data, error } = await callExternalApi({ config });
    return {
        data: data || null,
        error,
    };
};

export const deleteEventTickets = async (ticketIds, accessToken) => {
    const payload = {
        ids: ticketIds
    };

    const config = {
        url: `${apiServerUrl}/ticketinfo/`,
        method: "DELETE",
        data: payload,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        },
    };

    const { data, error } = await callExternalApi({ config });
    return {
        data: data || null,
        error,
    };
};

export const getEventTickets = async (eventId, accessToken) => {
    const config = {
        url: `${apiServerUrl}/ticketinfo/event/${eventId}`,
        method: "GET",
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
    };

    const { data, error } = await callExternalApi({ config });
    return {
        data: data || null,
        error,
    };
};

export const getCreatorProfile = async (accessToken) => {
    const config = {
        url: `${apiServerUrl}/creator-profile`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const getAudienceProfile = async (accessToken) => {
    const config = {
        url: `${apiServerUrl}/audience-profile`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const getStripeAccountLink = async (accessToken) => {
    
    const config = {
        url: `${apiServerUrl}/stripe-account-link`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const updateContentToEvent = async (eventId, contentIds, accessToken) => {
    const payload = {
        contentIds: contentIds,
        eventId: eventId
    }

    const config = {
        url: `${apiServerUrl}/updatecontenttoevent`,
        method: "POST",
        data: payload,
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const creatorSignUp = async (firstname, lastname, email, password, signupCode) => {
    const payload = {
        firstName: firstname,
        lastName: lastname,
        email: email,
        password: password,
        signup_code: signupCode
    }

    const config = {
        url: `${apiServerUrl}/creator-signup`,
        method: "POST",
        data: payload,
        headers: {
            "content-type": "application/json"
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const audienceSignUp = async (firstname, lastname, email, password) => {
    const payload = {
        firstName: firstname,
        lastName: lastname,
        email: email,
        password: password
    }

    const config = {
        url: `${apiServerUrl}/audience-signup`,
        method: "POST",
        data: payload,
        headers: {
            "content-type": "application/json"
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};


export const creatorToken = async (email, password) => {
    const payload = {
        email: email,
        password: password
    }

    const config = {
        url: `${apiServerUrl}/creator-token`,
        method: "POST",
        data: payload,
        headers: {
            "content-type": "application/json"
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const audienceToken = async (email, password) => {
    const payload = {
        email: email,
        password: password
    }

    const config = {
        url: `${apiServerUrl}/audience-token`,
        method: "POST",
        data: payload,
        headers: {
            "content-type": "application/json"
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const resetCreatorPassword = async (email) => {
    const payload = {
        email: email
    }

    const config = {
        url: `${apiServerUrl}/reset-password-creator`,
        method: "POST",
        data: payload,
        headers: {
            "content-type": "application/json"
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };

}

export const resetAudiencePassword = async (email) => {
    const payload = {
        email: email
    }

    const config = {
        url: `${apiServerUrl}/reset-password-audience`,
        method: "POST",
        data: payload,
        headers: {
            "content-type": "application/json"
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };

}

export const resendAudienceVerificationEmail = async (email) => {
    const payload = {
        email: email
    }

    const config = {
        url: `${apiServerUrl}/resend-verification-email-audience`,
        method: "POST",
        data: payload,
        headers: {
            "content-type": "application/json"
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };

}

export const resendCreatorVerificationEmail = async (email) => {
    const payload = {
        email: email
    }

    const config = {
        url: `${apiServerUrl}/resend-verification-email-creator`,
        method: "POST",
        data: payload,
        headers: {
            "content-type": "application/json"
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };

}

export const setCreatorProfile = async (info, accessToken) => {

    const config = {
        url: `${apiServerUrl}/creator-profile`,
        method: "POST",
        data: { info },
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const setAudienceProfile = async (info, accessToken) => {

    const config = {
        url: `${apiServerUrl}/audience-profile`,
        method: "POST",
        data: { info },
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

/**
 * Get resume position for a video
 */
export const getResumePosition = async (contentId, eventId = null, accessToken) => {
    const config = {
        url: `${apiServerUrl}/audience-engagement/resume-position`,
        method: "GET",
        params: {
            content_id: contentId,
            ...(eventId ? { event_id: eventId } : {})
        },
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

/**
 * Track viewing activity
 */
export const trackViewingActivity = async (activityData, accessToken) => {

    const config = {
        url: `${apiServerUrl}/audience-engagement/viewing-activity`,
        method: "POST",
        data: activityData,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

/**
 * Get user viewing history
 */
export const getUserViewingHistory = async (accessToken) => {

    const config = {
        url: `${apiServerUrl}/audience-engagement/user-history`,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

/**
 * Get content engagement statistics
 */
export const getContentStats = async (contentId, eventId = null, accessToken) => {

    const config = {
        url: `${apiServerUrl}/audience-engagement/content-stats/${contentId}`,
        method: "GET",
        params: eventId ? { event_id: eventId } : {},
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

/**
 * Get detailed activity timeline for a session
 */
export const getActivityTimeline = async (summaryId, accessToken) => {

    const config = {
        url: `${apiServerUrl}/audience-engagement/activity-timeline/${summaryId}`,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};